module.exports = __webpack_public_path__ + "img/fb-icon.7a3c5b64.svg";